import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { i18n, useRelevantCarousel as useRRCarousel } from '@mafc/common';
import { showNotification } from 'common/Notification/redux/notification.action';
import { notificationTypes } from 'common/Notification/redux/notification.type';
import { trackCartUpdation } from 'pages/Cart/components/UpdateQuantity/redux/updateQuantity.action';
import { getEarnedPoints } from 'pages/Cart/redux/actions';
import COLORS from 'theme/colors';
import { cartReponseShaper } from '../redux/actions/cartAction.helper';
import { updateCart } from '../redux/actions/fetchCart.actions';

const PLACEMENTS = 'cart_page.web_rank1|cart_page.web_rank2|cart_page.web_rank3';

const useRelevantCarousel = (productIds: string) => {
  const dispatch = useDispatch();

  const onSuccessCb = useCallback(
    (data: any) => {
      const { cart, entry } = data;
      const transformedCart = cartReponseShaper(cart);
      dispatch(getEarnedPoints());
      updateCart(dispatch, transformedCart);
      trackCartUpdation(true, entry);
    },
    [dispatch]
  );

  const onFailureCb = useCallback(
    (productName: string, data: any) => {
      const { meta } = data;
      dispatch(
        showNotification({
          type: notificationTypes.errorCheckout,
          message: meta && meta.message ? meta.message : i18n.t('addToCartError', { productName }),
        })
      );
    },
    [dispatch]
  );

  return useRRCarousel({
    placements: PLACEMENTS,
    withLoader: false,
    keyword: '',
    carouselOptions: { arrows: 'compact' },
    headingStyles: { mb: 3 },
    titleStyles: {
      color: COLORS.BLACK,
      fontSize: [1, 3],
      fontWeight: 5,
    },
    productId: productIds,
    variant: 'simple',
    isCart: true,
    onSuccessCb,
    onFailureCb,
  });
};

export default useRelevantCarousel;
